import { Badge } from "@/components/ui";
import { cn } from "@/lib/utils";
import { setMyCommunityCurrView } from "@/redux/slices";
import { RootState } from "@/redux/store";
import { useGetOccupancyListByCommunity } from "@/services";
import moment from "moment";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

const useUsersList = () => {
  const [globalFilter, setGlobalFilter] = useState("");
  const dispatch = useDispatch();

  const communityDetail = useSelector(
    (state: RootState) => state.currentData.communityData
  );

  const id = communityDetail?.communityId;
  const { data: communityUsers, isLoading: isLoadingCommunityUsers } =
    useGetOccupancyListByCommunity({
      communityId: id as string,
      queryParams: {
        enabled: !!id,
      },
    });

  const columns = [
    {
      accessorKey: "userName",
      header: "User ID",
    },
    {
      accessorKey: "firstName",
      header: "First Name",
    },
    {
      accessorKey: "lastName",
      header: "Last Name",
    },
    {
      accessorKey: "propertyName",
      header: "Property Name",
    },
    {
      accessorKey: "occupancyType",
      header: "Occupant Type",
    },
    {
      accessorKey: "startDate",
      header: "Start Date",
      cell: (row: any) => {
        return row.row.original.startDate
          ? moment(row.row.original.startDate).format("MM/DD/YYYY")
          : "";
      },
    },
    {
      accessorKey: "endDate",
      header: "End Date",
      cell: (row: any) => {
        return row.row.original.endDate
          ? moment(row.row.original.endDate).format("MM/DD/YYYY")
          : "";
      },
    },
    {
      accessorKey: "status",
      header: (
        <div className="flex items-center w-[80px] justify-center gap-2">
          Status
        </div>
      ),
      cell: (row: any) => {
        return (
          <Badge
            variant="outline"
            className={cn(
              row.row.original.endDate
                ? "border-red-600 bg-red-100 text-red-600"
                : "border-green-600 bg-green-100 text-green-600",
              "rounded-full px-4 py-2"
            )}
          >
            {row.row.original.endDate ? "Inactive" : "Active"}
          </Badge>
        );
      },
    },
    {
      accessorKey: "mobileNo",
      header: "Mobile No.",
    },
  ];

  const onBackClick = () => {
    dispatch(setMyCommunityCurrView(""));
  };

  return {
    columns,
    globalFilter,
    setGlobalFilter,
    isLoadingCommunityUsers,
    communityUsers,
    onCancel: onBackClick,
    communityDetail,
  };
};

export default useUsersList;
